export default "__VITE_ASSET__CK7gGGMW__"